"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupMISSING_SVC_ACCOUNT_SECRET = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

var texts_1 = require("../texts");

function setupMISSING_SVC_ACCOUNT_SECRET(builder) {
  builder.validator(validator_id_1.ValidatorID.MISSING_SVC_ACCOUNT_SECRET).category(categories_1.ValidatorCategory.RBAC).title('Unresolved Secret reference in ServiceAccount').description("Secrets are used to hold authentication tokens so ServiceAccounts can access\nKubernetes API Server.\n\nThis validator detects a condition when a Secret used in ServiceAccounts is not found.\n").affected('ServiceAccount').example("\napiVersion: v1\nkind: ServiceAccount\nmetadata:\n  creationTimestamp: 2015-06-16T00:12:59Z\n  name: build-robot\n  namespace: default\n  resourceVersion: \"272500\"\n  uid: 721ab723-13bc-11e5-aec2-42010af0021e\nsecrets:\n- name: build-robot-token-bvbk5              # Secret not found\n").resolution("Check if the Secret is present.").resolution(texts_1.RESOLUTION_TEXT.checkPresentInSameNamespace('Secret')).resolution(texts_1.RESOLUTION_TEXT.checkInDifferentNamespace('Secret', 'ServiceAccount')).resolution(texts_1.RESOLUTION_TEXT.typoNameReference('Secret', 'ServiceAccount')).externalLink('https://kubernetes.io/docs/tasks/configure-pod-container/configure-service-account/');
}

exports.setupMISSING_SVC_ACCOUNT_SECRET = setupMISSING_SVC_ACCOUNT_SECRET;